import perimeterTypes from "./modules/perimeterTypes"
import perimeters from "./modules/perimeters"
import doors from "./modules/doors"
import configurations from "./modules/configurations"
import methods from "./modules/methods";
import usersGroups from "./modules/usersGroups"
import access from "./modules/access"
import cards from "./modules/cards"


export default {
  modules: {
    perimeterTypes,
    perimeters,
    doors,
    configurations,
    usersGroups,
    access,
      cards,
    methods,

  }
}
